import { animate, inView, stagger } from 'motion'

export default ({ start = 'right', staggered = false, selector }) => ({
  start,
  staggered,
  selector,

  getElementForAnimation() {
    if (this.selector) {
      return this.$el.querySelectorAll(this.selector)
    } else {
      return this.$el
    }
  },

  getAnimation() {
    return {
      opacity: [0, 1],
      x:
        this.start === 'left'
          ? ['-100%', 0]
          : this.start === 'right'
            ? ['100%', 0]
            : 0,
      y:
        this.start === 'up'
          ? ['-200%', 0]
          : this.start === 'down'
            ? ['200%', 0]
            : 0,
    }
  },

  checkPrefersReducedMotion() {
    return !window.matchMedia('(prefers-reduced-motion: no-preference)').matches
  },

  init() {
    if (this.checkPrefersReducedMotion()) {
      return
    }

    inView(this.$el, () => {
      animate(this.getElementForAnimation(), this.getAnimation(), {
        duration: 0.6,
        delay: this.staggered ? stagger(0.2) : 0,
      })
    })
  },
})
